<template>

    <section class="list-view-section mx-xl-4 pt-3 pb-1" data-aos="fade-up">

        <draggable tag="div" :list="sets" v-bind="setsDragOptions" @change="elementsOrderChange">

            <div class="set-row" v-for="set in sets" :key="set.output_identification_name">

                <div class="set-heading" :class="{'checked': checkedSets.includes(set.output_identification_name)}">
                    <div class="handler set-handler" :class="{'hidden': selectedSortType !== 'order'}"></div>
                    <div class="name">{{ set.display_name }}</div>
                    <div class="ml-auto">&nbsp;</div>
                    <div class="edit-btn" @click="editSet(set)"></div>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="checkedSets" :value="set.output_identification_name" @change="checkedSetsChange(set.output_identification_name)">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>

                <div class="games">

                    <draggable tag="div" :list="set.games" v-bind="gamesDragOptions" @change="elementsOrderChange">

                        <div class="game-row" v-for="(game, index) in set.games" :key="game.output_identification_name" :class="{'checked': checkedGames.includes(game.output_identification_name)}">
                            <div class="handler game-handler" :class="{'hidden': selectedSortType !== 'order'}"></div>
                            <div class="mechanisms-color" :class="game.mechanism"></div>
                            <div class="number">{{ index+1 }}.</div>
                            <div class="name" :title="game.display_name">
                                <div class="text">{{ game.display_name }}</div>
                            </div>
                            <div class="description" :title="game.display_description">{{ game.display_description }}</div>
                            <a v-if="game.mechanism" :href="'/my-quizzes/edit-game/' + game.output_identification_name" class="edit-btn"></a>
                            <div class="checkbox" :class="{'ml-auto': game.mechanism === ''}">
                                <label>
                                    <input type="checkbox" v-model="checkedGames" :value="game.output_identification_name" @change="checkedGamesChange(game.output_identification_name)">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>

                    </draggable>

                    <div v-if="set.output_identification_name !== 'default'" class="add-game-btn" @click="addGame(set)">
                        <img src="/assets/images/quiz-add-element-btn.svg" class="icon" alt="">
                        <div class="text">{{ t.__('Dodaj grę') }}</div>
                    </div>

                </div>

            </div>

        </draggable>

        <div class="add-set-btn" @click="addSet()">
            <img src="/assets/images/quiz-add-element-btn.svg" class="icon" alt="">
            <div class="text">{{ t.__('Dodaj zestaw') }}</div>
        </div>

    </section>

</template>

<script>

import draggable from 'vuedraggable'

export default {

    name: 'MyQuizzesListView',

    components: {
        draggable
    },

    props: {
        sets: Array,
        selectedSortType: String
    },

    data() {
        return {
            eventHub: window.eventHub,
            checkedSets: [],
            checkedGames: [],
            setsDragOptions: {
                animation: 200,
                group: 'sets',
                disabled: false,
                ghostClass: 'ghost',
                handle: '.set-handler',
                draggable: '.set-row',
                dragoverBubble: true
            },
            gamesDragOptions: {
                animation: 200,
                group: 'games',
                disabled: false,
                ghostClass: 'ghost',
                handle: '.game-handler',
                draggable: '.game-row',
                dragoverBubble: true
            }
        };
    },

    beforeMount() {

        this.eventHub.$on('my-quizzes-delete-elements-start', () => {
            let data = {
                sets: this.checkedSets,
                games: this.checkedGames
            };
            axios.post('/my-quizzes/delete-elements', data)
                .then(response => {
                    this.eventHub.$emit('my-quizzes-update-sets', response.data.sets);
                    this.eventHub.$emit('my-quizzes-delete-elements-complete');
                    this.checkedSets = [];
                    this.checkedGames = [];
                })
                .catch(error => {
                    console.log(error);
                });
        });

    },

    methods: {

        checkedSetsChange(setOutputIdentificationName) {
            let set = this.sets.find(obj => {
                return obj.output_identification_name === setOutputIdentificationName
            });
            if (this.checkedSets.includes(setOutputIdentificationName)) {
                set.games.forEach(game => {
                   if (!this.checkedGames.includes(game.output_identification_name)) {
                       this.checkedGames.push(game.output_identification_name);
                   }
                });
            } else {
                set.games.forEach(game => {
                    if (this.checkedGames.includes(game.output_identification_name)) {
                        this.checkedGames.splice(this.checkedGames.indexOf(game.output_identification_name), 1);
                    }
                });
            }
        },

        checkedGamesChange(gameOutputIdentificationName) {
            let set = this.sets.find(objSet => {
                return objSet.games.find(objGame => {
                    return objGame.output_identification_name === gameOutputIdentificationName
                });
            });
            if (this.checkedSets.includes(set.output_identification_name)) {
                this.checkedSets.splice(this.checkedSets.indexOf(set.output_identification_name), 1);
            }
        },

        addSet() {
            this.eventHub.$emit('my-quizzes-add-set');
        },

        editSet(set) {
            this.eventHub.$emit('my-quizzes-edit-set', set);
        },

        addGame(set) {
            this.eventHub.$emit('my-quizzes-add-game', set);
        },

        elementsOrderChange() {
            this.eventHub.$emit('my-quizzes-order-changed', this.sets);
        }

    }

}
</script>

<style scoped>
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
